// @ts-nocheck
import 'core-js'
import React, { useEffect, useState, useCallback } from 'react'

import {
    Dialog as KDialog,
    DialogActionsBar as KDialogActionsBar,
} from '@progress/kendo-react-dialogs'
import {
    Grid,
    GridColumn,
    GridColumnMenuProps,
    GridColumnMenuItem,
} from '@progress/kendo-react-grid'
import { Label } from '@progress/kendo-react-labels'
import { DropDownList } from '@progress/kendo-react-dropdowns'
import { DatePicker, DateTimePicker } from '@progress/kendo-react-dateinputs'
import { Renderers } from './Renderers.js'
import { getTotalTime } from '../utils'
import './Modals.css'
import { getBaseURL } from '../../../GlobalComponents/URLs.jsx'
import { AWCButton } from '../../../GlobalComponents/Inputs/Inputs'
import { convertToCentralTime } from '../../../utils.ts'

const TECH_WEBSOCKET_URL = `${getBaseURL()}webapi/invtcategoryattribute/acAttributes/`
const INACTIVE_TIMER_URL = `${getBaseURL()}webapi/tags/inactiveTimers`
const STAGES_URL = `${getBaseURL()}webapi/tags/stages`
const TECHS_URL = `${getBaseURL()}webapi/tags/techs`
const WAREHOUSE_URL = `${getBaseURL()}webapi/warehouseget/warehouse`
const testData = [
    {
        TechUsername: 'MPRUTZ',
        Start: new Date(),
        Stop: new Date(),
        Stage: 'Test',
        Elapsed: 'a',
        TimeID: 20,
    },
    {
        TechUsername: 'MPRUTZ',
        Start: new Date(),
        Stop: new Date(),
        Stage: 'Test',
        Elapsed: 'a',
        TimeID: 30,
    },
]

interface Stage {
    Stage: string
    Rank: number
}
interface Tech {
    TechUsername: string
    WarehouseId: number
    FullName: string
}

interface TechTimer {
    TimeID: number
    TechUsername: string
    OrderNumber: string
    OrderTagId: number
    Start: Date
    Stop: Date | null
    DeliveryTicketNumber: string
    Tag: String
    Stage: String
}
const SAVE_TIMER_URL = `${getBaseURL()}webapi/tags/saveTimers`

export const TimeLogModal = (props) => {
    const close = () => null

    const [loading, setLoading] = React.useState(true)
    const [originalData, setOriginalData] = React.useState<Array<TechTimer>>([])
    const [data, setData] = React.useState<Array<TechTimer>>([])
    const [techList, setTechList] = React.useState<Array<Tech>>([])
    const [stageList, setStageList] = useState<Array<Stage>>([])
    const [warehouseMap, setWarehouseMap] = React.useState({})

    let { orderTagId } = props

    const getInactiveTags = async () => {
        let request = await fetch(INACTIVE_TIMER_URL + `/${orderTagId}`, { credentials: 'include' })
        let json = await request.json()
        let cleanedJson = json.map((row) => {
            let newRow = { ...row }
            newRow.Start = new Date(row.Start)
            newRow.Stop = row.Stop ? new Date(row.Stop) : null
            return newRow
        })
        setData(cleanedJson)
        setOriginalData(cleanedJson.map((row) => ({ ...row })))
    }

    const getTechList = async () => {
        let request = await fetch(TECHS_URL, { credentials: 'include' })
        let json = await request.json()
        json.sort((a, b) => (a.WarehouseId < b.WarehouseId ? -1 : 1))
        setTechList(json)
    }
    const getStageList = async () => {
        let request = await fetch(STAGES_URL, { credentials: 'include' })
        let json = await request.json()
        // json.sort((a, b) => (a.WarehouseId < b.WarehouseId ? -1 : 1));
        setStageList(json)
    }

    const getWarehouseMap = async () => {
        let request = await fetch(WAREHOUSE_URL, { credentials: 'include' })
        let json = await request.json()
        let warehouseMap = {}
        json.forEach((row) => {
            warehouseMap[parseInt(row.id)] = row
        })
        setWarehouseMap(warehouseMap)
    }

    useEffect(() => {
        getWarehouseMap()
        getInactiveTags()
        getTechList()
        getStageList()
    }, [])

    const getSavePayload = () => {
        const TimersChanged = []
        const TimersDeleted = []
        originalData.forEach((oldTimer) => {
            let newTimer = data.find((newTimer) => oldTimer.TimeID === newTimer.TimeID)
            if (!newTimer) {
                TimersDeleted.push({ TimeID: oldTimer.TimeID })
            }
        })
        data.forEach((newTimer) => {
            let oldTimer = originalData.find((oldTimer) => oldTimer.TimeID === newTimer.TimeID)

            let changes = { TimeID: newTimer.TimeID }
            for (let key in oldTimer) {
                if (oldTimer[key] !== newTimer[key]) {
                    changes[key] = newTimer[key]
                }
            }
            // add if not only TimeID
            if (Object.keys(changes).length > 1) TimersChanged.push(changes)
        })
        return { TimersChanged, TimersDeleted }
    }

    const saveTimers = async () => {
        let payload = getSavePayload()
        if (!orderTagId || orderTagId < 1) {
            alert(`Invalid order tag id ${orderTagId}`)
            return
        }
        let request = await fetch(SAVE_TIMER_URL + `/${props.orderTagId}`, {
            method: 'POST',
            body: JSON.stringify(payload),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        if (!request.ok) {
            alert('Error saving timers')
        }
    }
    const enterEdit = (dataItem, field) => {
        setData((data) =>
            data.map((item) => ({
                ...item,
                inEdit: item['TimeID'] === dataItem['TimeID'] ? field : undefined,
            }))
        )
    }

    const exitEdit = () => {
        setData((data) => data.map((item) => ({ ...item, inEdit: undefined })))
    }

    const itemChange = (event) => {
        const inEditID = event.dataItem['TimeID']
        let newData = data.map((item) => {
            return item['TimeID'] === inEditID ? { ...item, [event.field]: event.value } : item
        })
        setData(newData)
    }

    const renderers = new Renderers(enterEdit, exitEdit, 'inEdit')

    const GridDate = (props) => {
        const { dataItem } = props
        return (
            <td>
                <DateTimePicker
                    value={dataItem[props.field]}
                    onChange={(event) => {
                        props.onChange({
                            dataItem: props.dataItem,
                            syntheticEvent: event.syntheticEvent,
                            field: props.field,
                            value: event.value,
                        })
                    }}
                />
            </td>
        )
    }

    const GridStartStop = (props) => {
        const { dataItem } = props
        const currentValStart = React.useRef(null)
        const currentValStop = React.useRef(null)
        return (
            <td>
                <div style={{ display: 'flex' }}>
                    <Label editorId={props.dataItem.TimeID + 'start'} style={{ width: 40 }}>
                        Start
                    </Label>
                    <DateTimePicker
                        defaultValue={dataItem.Start}
                        id={props.dataItem.TimeID + 'start'}
                        onChange={(event) => {
                            currentValStart.current = {
                                dataItem: props.dataItem,
                                syntheticEvent: event.syntheticEvent,
                                field: 'Start',
                                value: event.value,
                            }
                        }}
                        onBlur={(event) => {
                            if (currentValStart.current) props.onChange(currentValStart.current)
                        }}
                        // onBlur
                    />
                </div>
                <div style={{ display: 'flex' }}>
                    <Label style={{ width: 40 }}>Stop</Label>
                    <DateTimePicker
                        defaultValue={dataItem.Stop}
                        onChange={(event) => {
                            currentValStop.current = {
                                dataItem: props.dataItem,
                                syntheticEvent: event.syntheticEvent,
                                field: 'Stop',
                                value: event.value,
                            }
                        }}
                        onBlur={(event) => {
                            if (currentValStop.current) props.onChange(currentValStop.current)
                        }}
                    />
                </div>
            </td>
        )
    }

    const GridElapsed = (props) => {
        const { dataItem, field } = props
        let timer = getTotalTime(dataItem.Start, dataItem.Stop || convertToCentralTime(new Date()))
        return (
            <td>
                <div className='centeredText'>
                    {dataItem.Stop ? (
                        `${timer.hours.toString().padStart(2, '0')}:${timer.minutes
                            .toString()
                            .padStart(2, '0')}:${timer.seconds.toString().padStart(2, '0')}`
                    ) : (
                        <TimerText startTime={dataItem.Start} />
                    )}
                </div>
            </td>
        )
    }
    const GridTechDropDown = (props) => {
        let options = ['AWC', 'MPRUTZ', 'MORGAN', 'JEREMY']
        const { dataItem, field } = props
        // const [value, setValue] = useState(dataItem[field]);
        const itemRender = (li, itemProps) => {
            const index = itemProps.index
            let { dataItem } = itemProps
            const itemChildren = <span>{dataItem.string}</span>
            if (dataItem.isWarehouse)
                return (
                    <li>
                        <span style={{ color: '#AAA' }}>{dataItem.string}</span>
                    </li>
                )
            return React.cloneElement(li, li.props, itemChildren)
        }
        let lastWarehouse = undefined
        let fullList = []
        techList.forEach((tech) => {
            let warehouse = warehouseMap[tech.WarehouseId] && warehouseMap[tech.WarehouseId].name
            if (warehouse !== lastWarehouse) fullList.push({ string: warehouse, isWarehouse: true })
            lastWarehouse = warehouse
            fullList.push({ string: tech.FullName, techUsername: tech.TechUsername })
        })
        return (
            <td>
                <DropDownList
                    data={fullList}
                    value={fullList.find((row) => row.techUsername === dataItem[props.field])}
                    textField={'string'}
                    itemRender={itemRender}
                    popupSettings={{
                        width: 250,
                    }}
                    onChange={(event) => {
                        props.onChange({
                            dataItem: props.dataItem,
                            syntheticEvent: event.syntheticEvent,
                            field: props.field,
                            value: event.value.techUsername,
                        })
                    }}
                />
            </td>
        )
    }

    const GridStageDropDown = (props) => {
        let options = ['Start', 'Assembling', 'Test', 'Completed']
        const { dataItem, field } = props
        // const [value, setValue] = useState(dataItem[field]);

        return (
            <td>
                <DropDownList
                    data={stageList}
                    value={stageList.find((row) => row.Stage === dataItem[props.field])}
                    textField={'Stage'}
                    popupSettings={{
                        width: 230,
                    }}
                    onChange={(event) => {
                        props.onChange({
                            dataItem: props.dataItem,
                            syntheticEvent: event.syntheticEvent,
                            field: props.field,
                            value: event.value.Stage,
                        })
                    }}
                />
            </td>
        )
    }

    const GridDeleteColumn = (props) => {
        let options = ['Start', 'Assembling', 'Test', 'Completed']
        const { dataItem, field } = props
        // const [value, setValue] = useState(dataItem[field]);

        return (
            <td>
                <div className='centeredText'>
                    <span
                        className='k-icon k-i-close k-i-x'
                        style={{ cursor: 'pointer' }}
                        onClick={() => dataItem.deleteRow(dataItem.TimeID)}
                    ></span>
                </div>
            </td>
        )
    }

    const deleteRow = (TimeID) => {
        setData((data) => data.filter((row) => row.TimeID !== TimeID))
    }

    const TimerText = ({ startTime }) => {
        const [refresh, setRefresh] = React.useState([])

        React.useEffect(() => {
            setInterval(() => setRefresh([]), 1000)
        }, [])

        let currentTimerObj = getTotalTime(startTime, new Date())

        return (
            <>
                {`${(currentTimerObj.hours * 60 + currentTimerObj.minutes)
                    .toString()
                    .padStart(2, '0')}:${currentTimerObj.seconds.toString().padStart(2, '0')}`}
            </>
        )
    }

    return (
        <div onClick={props.close}>
            <KDialog title={'Time Log'} width={955}>
                <div
                    onClick={(e) => {
                        e.stopPropagation()
                    }}
                >
                    <Grid
                        style={{ height: 200 }}
                        cellRender={renderers.cellRender}
                        rowRender={renderers.rowRender}
                        pageable={false}
                        pageSize={40}
                        total={data.length}
                        data={data.map((row) => ({ ...row, deleteRow }))}
                        skip={0}
                        resizable={false}
                        // detail={DetailComponent}
                        // onItemChange={itemChange}
                        editField='inEdit'
                        onItemChange={itemChange}
                        scrollable={'scrollable'}
                        key={'modalGrid'}
                        // Tech Start Stop Elapsed Stage
                    >
                        <GridColumn
                            cell={GridTechDropDown}
                            field={'TechUsername'}
                            editable={true}
                            editor={'text'}
                            width='173px'
                            resizable={false}
                            key={'tech'}
                        />
                        <GridColumn
                            cell={GridStartStop}
                            // field={'Stop'}
                            title={'Start/Stop'}
                            editable={true}
                            editor={'date'}
                            width='270px'
                            // format="M/dd/yy hh:mm a"
                            resizable={false}
                        />
                        <GridColumn
                            cell={GridStageDropDown}
                            field={'Stage'}
                            editable={true}
                            editor={'text'}
                            width='235px'
                            resizable={false}
                        />
                        <GridColumn
                            field={'Elapsed'}
                            cell={GridElapsed}
                            editable={false}
                            editor={'text'}
                            width='110px'
                            resizable={false}
                        />
                        <GridColumn
                            title={'Delete'}
                            cell={GridDeleteColumn}
                            editable={false}
                            width='100px'
                            resizable={false}
                        />
                    </Grid>
                </div>
                <KDialogActionsBar>
                    <AWCButton type={'blue'} onClick={saveTimers}>
                        Save
                    </AWCButton>
                    <AWCButton type={'secondary'} onClick={props.close}>
                        Close
                    </AWCButton>
                </KDialogActionsBar>
            </KDialog>
        </div>
    )
}
